module.exports = __webpack_public_path__ + "img/人像-1.2885720b.png";